"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var colorBgSecondary = _a.colorBgSecondary,
      colorSuccess = _a.colorSuccess,
      colorError = _a.colorError,
      colorNotify = _a.colorNotify;
  return {
    base: {
      display: 'inline-block',
      transform: 'rotate(-90deg)'
    },
    substrate: {
      stroke: colorBgSecondary.normal
    },
    success: {
      stroke: colorSuccess.normal
    },
    warning: {
      stroke: colorNotify.normal
    },
    error: {
      stroke: colorError.normal
    },
    blank: {
      stroke: colorBgSecondary.normal
    },
    circle: {
      strokeLinecap: 'round'
    },
    determinate: {}
  };
};